module.exports = __webpack_public_path__ + "img/mianfei.e67d5071.png";